(function () {
  const wrappers = document.querySelectorAll('[data-custom-select]');

  wrappers.forEach((wrapper) => {
    const nativeSelect = wrapper.querySelector('[data-native-select]');
    const dropdown     = wrapper.querySelector('[data-dropdown]');
    const toggle       = wrapper.querySelector('[data-dropdown-toggle]');
    const label        = wrapper.querySelector('[data-dropdown-label]');
    const list         = wrapper.querySelector('[data-dropdown-list]');
    const items        = list.querySelectorAll('.thb-custom-dropdown__item');

    if (!nativeSelect || !dropdown) return;

    const openDropdown = () => {
      closeAllDropdowns();
      // Prefer opening upward (footer context), but flip downward when the
      // viewport doesn't have room above the toggle.
      const rect = toggle.getBoundingClientRect();
      const listHeight = Math.min(list.scrollHeight, 260) + 8;
      const spaceAbove = rect.top;
      const spaceBelow = window.innerHeight - rect.bottom;
      dropdown.classList.toggle(
        'thb-custom-dropdown--down',
        spaceAbove < listHeight && spaceBelow > spaceAbove
      );
      dropdown.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    };

    const closeDropdown = () => {
      dropdown.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    };

    // Toggle 
    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      dropdown.classList.contains('is-open') ? closeDropdown() : openDropdown();
    });

    
    items.forEach((item) => {
      const selectItem = () => {
        const value = item.getAttribute('data-value');
        const labelText = item.getAttribute('data-label');

        // Update UI
        items.forEach((i) => {
          i.classList.remove('is-selected');
          i.setAttribute('aria-selected', 'false');
        });
        item.classList.add('is-selected');
        item.setAttribute('aria-selected', 'true');
        label.textContent = labelText;

       
        nativeSelect.value = value;
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));

        closeDropdown();
      };

      item.addEventListener('click', selectItem);
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectItem();
        }
      });
    });
  });


  function closeAllDropdowns() {
    document.querySelectorAll('[data-dropdown].is-open').forEach((d) => {
      d.classList.remove('is-open');
      const tg = d.querySelector('[data-dropdown-toggle]');
      if (tg) tg.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-dropdown]')) {
      closeAllDropdowns();
    }
  });

  
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAllDropdowns();
  });
})();